export type VideoItem = {
  src: string;
  label: string;
  description: string;
  transcript: string;
  orientation?: "portrait" | "landscape";
  vimeoId: string;
  uploadDate?: string;
  thumbnailUrl?: string;
};

export const videos: VideoItem[] = [
  {
    src: "https://player.vimeo.com/video/1193190086",
    label: "Noteneingabe & Quotenwahl – ncrechner App Tutorial",
    description: "Ein schneller Überblick über die ncrechner App: Noteneingabe, Quotenwahl und Ergebnisinterpretation.",
    transcript:
      "In diesem Video zeigen wir dir, wie du die ncrechner App startest, deine Abiturnote eingibst und die passenden Zulassungsquoten auswählst. Wir erklären dir außerdem die wichtigsten Begriffe wie ABQ, AdH und ZEQ.",
    orientation: "portrait",
    vimeoId: "1193190086",
    uploadDate: "2024-01-15",
    thumbnailUrl: "https://i.vimeocdn.com/video/1193190086.webp",
  },
  {
    src: "https://player.vimeo.com/video/1193190033",
    label: "Daten eingeben & Hochschulen vergleichen",
    description: "So gibst du deine Leistungen in der App ein und vergleichst verschiedene Hochschulen miteinander.",
    transcript:
      "Dieses Video führt dich Schritt für Schritt durch die Eingabe deiner Abiturdaten, die Auswahl der gewünschten Studiengänge und den Vergleich der Zulassungsgrenzen verschiedener Universitäten.",
    orientation: "portrait",
    vimeoId: "1193190033",
    uploadDate: "2024-01-15",
    thumbnailUrl: "https://i.vimeocdn.com/video/1193190033.webp",
  },
  {
    src: "https://player.vimeo.com/video/1193190032",
    label: "Quoten erklärt: ABQ, AdH & ZEQ verstehen",
    description: "Erklärung der verschiedenen Quoten und ihrer Wirkung auf deine Zulassungschancen.",
    transcript:
      "Hier erklären wir dir die Unterschiede zwischen ABQ, AdH und ZEQ. Du lernst, welche Kriterien in den verschiedenen Quoten relevant sind und wie die App deine Chancen berechnet.",
    orientation: "portrait",
    vimeoId: "1193190032",
    uploadDate: "2024-01-15",
    thumbnailUrl: "https://i.vimeocdn.com/video/1193190032.webp",
  },
  {
    src: "https://player.vimeo.com/video/1193190034",
    label: "Ergebnisse interpretieren & nächste Schritte planen",
    description: "So interpretierst du die Ergebnisse der ncrechner App und planst deine nächste Bewerbungsschritte.",
    transcript:
      "In diesem Abschnitt zeigen wir dir, wie du die Ergebnisse richtig liest, mögliche Schwachstellen erkennst und deine nächste Bewerbung effektiv vorbereitest.",
    orientation: "portrait",
    vimeoId: "1193190034",
    uploadDate: "2024-01-15",
    thumbnailUrl: "https://i.vimeocdn.com/video/1193190034.webp",
  },
  {
    src: "https://player.vimeo.com/video/1193190035",
    label: "Dienste, Ausland & Bewerbungsoptimierung",
    description: "Tipps zur Nutzung von Zusatzdiensten, zum Umgang mit Auslandseinrichtungen und zur Optimierung deiner Bewerbung.",
    transcript:
      "Dieses Video gibt dir praktische Tipps für Dienste, Auslandsbewerbungen und wie du die App zur Maximierung deiner Chancen nutzen kannst.",
    orientation: "portrait",
    vimeoId: "1193190035",
    uploadDate: "2024-01-15",
    thumbnailUrl: "https://i.vimeocdn.com/video/1193190035.webp",
  },
];
